// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--3k-tr","Zoom":"Zoom--2KEnL","Table":"Table--KBLX9"};